import { useState } from "react";
import { motion } from "framer-motion";
import { db } from "../../../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import classes from "../More.module.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // 🔑 prevent page refresh

    try {
      await addDoc(collection(db, "contactus"), {
        ...formData,
        createdAt: serverTimestamp(),
      });
      setSubmitted(true);
    } catch (error) {
      console.error("Error saving message:", error);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <motion.div
      className={classes.page}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {!submitted ? (
        <>
          <h1>Contact Us</h1>
          <p>
            We’d love to hear from you. Whether you have questions, feedback, or
            just want to say hi, feel free to reach out.
          </p>

          <form className={classes.form} onSubmit={handleSubmit}>
            <label>
              Name
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
              />
            </label>
            <label>
              Email
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@example.com"
                required
              />
            </label>
            <label>
              Message
              <textarea
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your message..."
                required
              />
            </label>
            <button type="submit">Send</button>
          </form>
        </>
      ) : (
        <div className={classes.thankYou}>
          <h1>Thanks for contacting us!</h1>
          <p>We’ll reach back out shortly.</p>
        </div>
      )}
    </motion.div>
  );
};

export default ContactUs;
